import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OpportunityRoutingModule } from '@shared/lib/lazy-modules/opportunity/opportunity-routing.module';
import { OpportunityComponent } from '@shared/lib/lazy-modules/opportunity/components/opportunity/opportunity.component';
import { DeferLoadModule } from '@shared/lib/modules/defer-load.module';
import { BeComponent } from '@shared/lib/components/be/be.component';
import { UsanaTranslationsModule } from '@usana/ux/translations';
import { EarnComponent } from '@shared/lib/components/earn/earn.component';
import { BossComponent } from '@shared/lib/components/boss/boss.component';
import { HeroModule } from '@shared/lib/components/hero/hero.module';
import { ShareTableComponent } from '@shared/lib/components/share/share.component';
import { TrimPipeModule } from '../../pipes/trim-pipe.module';

@NgModule({
  declarations: [
    OpportunityComponent,
    BeComponent,
    EarnComponent,
    BossComponent,
    ShareTableComponent
  ],
  imports: [
    CommonModule,
    OpportunityRoutingModule,
    UsanaTranslationsModule,
    DeferLoadModule,
    HeroModule,
    TrimPipeModule,
  ],
})
export class OpportunityModule {}
